import script from "./SwipeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwipeModal.vue?vue&type=script&setup=true&lang=ts"

import "./SwipeModal.vue?vue&type=style&index=0&id=742dd278&lang=scss"

const __exports__ = script;

export default __exports__